import React from 'react';

import { IconButton, Tooltip } from '@mui/material';
import { DocumentDownload } from 'iconsax-react';

import { useSelector, useTranslation } from 'third-party';

import { settingSelectors } from 'selectors';

export const ExportTemplate = () => {
  const document = useSelector(settingSelectors.emailTemplate);
  const loadEmailTemplatePending = useSelector(
    settingSelectors.loadEmailTemplatePending,
  );
  const saveSettingPending = useSelector(settingSelectors.saveSettingPending);

  const disabledExport = saveSettingPending || loadEmailTemplatePending;

  const { t } = useTranslation();

  const content = `data:text/plain,${encodeURIComponent(
    JSON.stringify(document, null, '  '),
  )}`;

  return (
    <Tooltip title={t('emailDesigner.actions.exportTemplate')}>
      <IconButton
        disabled={disabledExport}
        href={content}
        download="emailTemplate.json"
      >
        <DocumentDownload variant="TwoTone" size="20" />
      </IconButton>
    </Tooltip>
  );
};
